import { InMemoryCache } from '@apollo/client/core';

import result, {
  ReferenceType,
  TypedTypePolicies,
  Vehicle as VehicleModel,
  VehicleExtended as VehicleExtendedModel,
  Driver as DriverModel,
} from './generated';
import {
  Driver,
  DriverCard,
  DriverStatusType,
  DriverUnknown,
  Eta,
  EtaArrival,
  EtaLightTask,
  Incident,
  MapModuleClientSettings,
  MapModuleSettings,
  OrderTask,
  TachoRemoteCompanyCardType,
  Task,
  UserPoint,
  Vehicle,
  VehicleExtended,
  VehicleCurrentType,
  VehicleDeviceType,
  VehicleGroupType,
} from './type-policies';

const typePolicies: TypedTypePolicies = {
  Task,
  EtaArrival,
  EtaLightTask,
  Incident,
  OrderTask,
  MapModuleSettings,
  Driver,
  DriverUnknown,
  Vehicle,
  VehicleExtended,
  VehicleDeviceType,
  VehicleCurrentType,
  DriverStatusType,
  MapModuleClientSettings,
  UserPoint,
  VehicleGroupType,
  Eta,
  DriverCard,
  TachoRemoteCompanyCardType,
  Me: {
    fields: {
      vehicle: {
        read(values, { args, toReference }) {
          if (args?.id != null) {
            return [toReference(<ReferenceType<VehicleExtendedModel>>{ __typename: 'VehicleExtended', id: args.id })];
          }

          return values;
        },
      },
      vehicles: {
        read(values, { args, toReference }) {
          if (args?.id != null) {
            return [toReference(<ReferenceType<VehicleModel>>{ __typename: 'Vehicle', id: args.id })];
          }

          return values;
        },
      },
      drivers: {
        read(values, { args, toReference }) {
          if (args?.id != null) {
            return [toReference(<ReferenceType<DriverModel>>{ __typename: 'Driver', id: args.id })];
          }

          return values;
        },
      },
    },
  },
  TachoRemoteType: {
    merge: true,
  },
  Query: {
    fields: {
      me: {
        merge: true,
      },
    },
  },
  Mutation: {
    fields: {
      etaLightTask: {
        merge: true,
      },
    },
  },
};

export const memoryCache: () => InMemoryCache = () => {
  return new InMemoryCache({
    possibleTypes: result.possibleTypes,
    typePolicies,
  });
};
